<template>
  <div class="left-panel">
    <dv-border-box-12 class="panel-box kpi-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">核心KPI指标</span>
        </div>
        <div class="kpi-list">
          <div
            v-for="(item, index) in leftKpiItems"
            :key="index"
            class="kpi-item"
            :style="{ '--dot-color': dotColors[index % dotColors.length] }"
          >
            <span class="kpi-dot"></span>
            <div class="kpi-info">
              <div class="kpi-name">{{ item.label }}</div>
              <div class="kpi-val-row">
                <span class="kpi-val">{{ item.value.toLocaleString() }}</span>
                <span class="kpi-u">{{ item.unit }}</span>
              </div>
              <!-- 迷你进度条 -->
              <div class="kpi-mini-bar">
                <div class="kpi-mini-fill" :style="{ width: progressMap[index] + '%', background: dotColors[index % dotColors.length] }"></div>
              </div>
            </div>
            <div class="kpi-badge" :class="item.change >= 0 ? 'up' : 'down'">
              {{ item.change >= 0 ? '+' : '' }}{{ item.change }}%
            </div>
          </div>
        </div>
      </div>
    </dv-border-box-12>
    <dv-border-box-12 class="panel-box category-section">
      <div class="panel-inner">
        <div class="section-title">
          <dv-decoration-6 style="width:200px;height:20px;" />
          <span class="title-text">品类销售分布</span>
        </div>
        <CategoryPie />
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import { leftKpiItems } from '../mock/data'
import CategoryPie from './CategoryPie.vue'

export default {
  name: 'LeftPanel',
  components: { CategoryPie },
  data() {
    return {
      leftKpiItems,
      /* 圆点颜色循环 */
      dotColors: ['#00D4FF', '#00FF88', '#FF6B35', '#A855F7', '#F59E0B', '#EC4899'],
      /* 各KPI进度比例 */
      progressMap: [75, 85, 60, 55, 40, 85]
    }
  }
}
</script>

<style scoped>
.left-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.panel-box {
  min-height: 300px;
}

.panel-inner {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.title-text {
  font-size: 15px;
  font-weight: bold;
  color: #00D4FF;
  white-space: nowrap;
}

.kpi-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.kpi-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 4px;
  transition: all 0.3s;
}

.kpi-item:hover {
  background: rgba(0, 212, 255, 0.1);
}

/* 纯CSS小圆点 */
.kpi-dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--dot-color);
  box-shadow: 0 0 6px var(--dot-color);
}

.kpi-info {
  flex: 1;
  min-width: 0;
}

.kpi-name {
  font-size: 11px;
  color: #B0D4F1;
}

.kpi-val-row {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.kpi-val {
  font-size: 16px;
  font-weight: bold;
  font-family: 'DIN', 'Courier New', monospace;
  background: linear-gradient(180deg, #FFFFFF 0%, var(--dot-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.kpi-u {
  font-size: 11px;
  color: #B0D4F1;
}

/* 迷你进度条 */
.kpi-mini-bar {
  height: 3px;
  background: rgba(0, 212, 255, 0.08);
  border-radius: 2px;
  margin-top: 4px;
  overflow: hidden;
}

.kpi-mini-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.6s ease;
}

.kpi-badge {
  font-size: 12px;
  font-weight: bold;
  font-family: 'DIN', 'Courier New', monospace;
  padding: 2px 6px;
  border-radius: 3px;
}

.kpi-badge.up {
  color: #00FF88;
  background: rgba(0, 255, 136, 0.1);
}

.kpi-badge.down {
  color: #FF6B35;
  background: rgba(255, 107, 53, 0.1);
}
</style>
